/**
 * Suppression d'une conception pendant la phase de soumission (groupe 1 / ordre 1),
 * libellée « Soumission de la commande » (nom de phase contenant soumission + commande).
 * Autorisé : administrateur ou dentiste propriétaire (cases.user_profile_id).
 */

export function canDeleteCaseInSubmissionPhase({
  userRole,
  currentUserId,
  caseData,
  timelinePhaseItems = [],
}) {
  if (!caseData?.id || !currentUserId) return false;

  const allowedRole =
    userRole === 'administrator' ||
    (userRole === 'dentist_client' && caseData.dentistId === currentUserId);
  if (!allowedRole) return false;

  const submission = timelinePhaseItems.find(
    (p) => String(p.group ?? '') === '1' && p.phase_order === 1
  );
  if (!submission) return false;

  if (!['pending', 'in_progress'].includes(submission.status)) return false;

  const name = (submission.name || '').toLowerCase();
  const isOrderSubmissionPhaseLabel =
    name.includes('soumission') && name.includes('commande');

  if (!isOrderSubmissionPhaseLabel) return false;

  if (['completed', 'cancelled'].includes(caseData.status)) return false;

  // Cas « Soumis » uniquement après « Envoyer Conception » (phase passée en submitted).
  // Ancien sync auto : statut cas = submitted alors que la phase est encore in_progress → suppression OK.
  if (caseData.status === 'submitted') {
    return submission.status === 'in_progress';
  }

  return true;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} caseId
 * @returns {Promise<{ ok: boolean, error?: string, detail?: string }>}
 */
export async function deleteCaseInSubmissionPhaseRpc(supabase, caseId) {
  const { data, error } = await supabase.rpc('delete_case_in_submission_phase', {
    p_case_id: caseId,
  });

  if (error) {
    return { ok: false, error: error.message || 'rpc_error' };
  }

  const row = data && typeof data === 'object' ? data : {};
  if (!row.ok) {
    return {
      ok: false,
      error: row.error || 'delete_failed',
      detail: row.detail,
    };
  }

  return { ok: true };
}
